import {Model, IPhone} from 'MWC';
import queryParams from '../queries/form.m.q';

export default class extends Model {
    static queryParams = queryParams;

    static protocol = null;

    static fields = {
        // name: {
        //     notNull: true,
        //     format: /^[A-Za-z\sа-яїєёі\-']{2,40}$/i,
        //     value: null,
        // },
        phone: {
            notNull: true,
            fieldConstructor: IPhone,
            value: null
        }
    };
}
